import type { Palette } from '@mui/material';
import type { TypographyOptions } from '@mui/material/styles/createTypography';

const typography = (palette: Palette): TypographyOptions => ({
  fontFamily: '"Nunito Sans","Roboto"',
  fontWeightLight: 200,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '35px',
    lineHeight: '40px',
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '29px',
    lineHeight: '32px',
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '28px',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '24px',
  },
  h5: {
    color: palette.primary.dark,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
  },
  h6: {
    color: palette.primary.dark,
    fontWeight: 600,
    fontSize: '13px',
    lineHeight: '20px',
  },
  subtitle1: {
    color: palette.text.primary,
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '25px',
  },
  subtitle2: {
    color: palette.primary.main,
    fontWeight: 600,
    fontSize: '13px',
    lineHeight: '18px',
  },
  body1: {
    color: palette.text.primary,
    fontSize: '13px',
    lineHeight: '18px',
  },
  body2: {
    color: palette.secondary.dark,
    fontSize: '13px',
    lineHeight: '18px',
  },
  button: {
    color: palette.text.primary,
    fontSize: '14px',
  },
  caption: {
    color: palette.secondary.dark,
    fontSize: '12px',
    letterSpacing: '0.5px',
    lineHeight: '24px',
    textTransform: 'uppercase',
  },
  overline: {
    color: palette.primary.dark,
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '23px',
    textTransform: 'uppercase',
  },
});

export default typography;
